module.exports = __webpack_public_path__ + "static/media/projects_management_icon.7a909c97.png";